"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomerPaymentMethodBillingContactUpdateTransport = exports.CustomerPaymentMethodPartialUpdateTransport = exports.ListCustomerPaymentMethodsQuery = exports.CustomerPaymentMethodUpdateTransport = exports.CustomerPaymentMethodTransport = exports.enrichCustomerPaymentMethod = exports.toTypedProcessingPaymentMethodDetails = exports.RAINFOREST_METHOD_TYPE_TO_STORED = exports.WalletProcessingPaymentMethodDetails = exports.AchProcessingPaymentMethodDetails = exports.CardProcessingPaymentMethodDetails = exports.ProcessingPaymentMethodCommonDetails = exports.ProcessingPaymentMethodBillingContact = exports.AchAccountHolderTypeLabels = exports.AchAccountTypeLabels = exports.ProcessingAchBackedFields = exports.AchAccountHolderType = exports.AchAccountType = exports.ProcessingCardBackedFields = exports.CustomerPaymentMethodStatusNoteTransport = exports.CustomerPaymentMethodStatusReasonSchema = exports.CustomerPaymentMethodStatusReasons = exports.UsableCustomerPaymentMethodStatuses = exports.CustomerPaymentMethodStatusSchema = exports.CustomerPaymentMethodStatuses = exports.CustomerPaymentMethodCreateTransport = void 0;
const typebox_1 = require("@sinclair/typebox");
const common_1 = require("../common");
const stored_payment_method_type_1 = require("../invoice/stored-payment-method-type");
exports.CustomerPaymentMethodCreateTransport = typebox_1.Type.Object({
    paymentMethodID: typebox_1.Type.String({ minLength: 1, maxLength: 255 }),
    paymentMethodFingerprint: typebox_1.Type.Optional(typebox_1.Type.String()),
    type: stored_payment_method_type_1.StoredPaymentMethodType,
});
/**
 * Lifecycle state of a stored payment method. DELETED is never returned by the API; EXPIRED and
 * BLOCKED are returned only when a caller names them explicitly. The remaining statuses are all
 * states in which the method may still be charged.
 */
exports.CustomerPaymentMethodStatuses = [
    'ACTIVE',
    'VERIFYING',
    'VERIFIED',
    'UNVERIFIED',
    'EXPIRED',
    'BLOCKED',
    'DELETED',
];
exports.CustomerPaymentMethodStatusSchema = typebox_1.Type.Union(exports.CustomerPaymentMethodStatuses.map((status) => typebox_1.Type.Literal(status)));
/** Statuses a payment method may be charged under, and the default set the list endpoints return. */
exports.UsableCustomerPaymentMethodStatuses = [
    'ACTIVE',
    'VERIFYING',
    'VERIFIED',
    'UNVERIFIED',
];
/**
 * Why a payment method was moved to its current status. Vocabulary is deliberately shared across
 * every status rather than scoped to one, so a new status can reuse the terms that fit it without
 * the set having to be partitioned per status.
 */
exports.CustomerPaymentMethodStatusReasons = [
    'SUSPECTED_FRAUD',
    'COMPROMISED_CARD',
    'CUSTOMER_REQUEST',
    'CHARGEBACK_DISPUTE',
    'OTHER',
];
exports.CustomerPaymentMethodStatusReasonSchema = typebox_1.Type.Union(exports.CustomerPaymentMethodStatusReasons.map((reason) => typebox_1.Type.Literal(reason)));
/**
 * One entry in a payment method's status history. A row is appended every time the method moves to
 * a new status, carrying the operator-supplied explanation for that move.
 */
exports.CustomerPaymentMethodStatusNoteTransport = typebox_1.Type.Object({
    id: typebox_1.Type.String({ format: 'uuid' }),
    customerPaymentMethodID: typebox_1.Type.String({ format: 'uuid' }),
    status: exports.CustomerPaymentMethodStatusSchema,
    reason: typebox_1.Type.Optional(exports.CustomerPaymentMethodStatusReasonSchema),
    note: typebox_1.Type.Optional(typebox_1.Type.String()),
    createdAt: typebox_1.Type.String({ format: 'date-time' }),
    updatedAt: typebox_1.Type.String({ format: 'date-time' }),
    createdByUserID: typebox_1.Type.String({ format: 'uuid' }),
    updatedByUserID: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'uuid' })),
});
exports.ProcessingCardBackedFields = typebox_1.Type.Object({
    brand: typebox_1.Type.Optional(typebox_1.Type.String()),
    brandDescription: typebox_1.Type.Optional(typebox_1.Type.String()),
    lastFour: typebox_1.Type.Optional(typebox_1.Type.String()),
    expirationMonth: typebox_1.Type.Optional(typebox_1.Type.Number()),
    expirationYear: typebox_1.Type.Optional(typebox_1.Type.Number()),
});
exports.AchAccountType = typebox_1.Type.Union([typebox_1.Type.Literal('CHECKING'), typebox_1.Type.Literal('SAVINGS')]);
exports.AchAccountHolderType = typebox_1.Type.Union([typebox_1.Type.Literal('PERSONAL'), typebox_1.Type.Literal('BUSINESS')]);
exports.ProcessingAchBackedFields = typebox_1.Type.Object({
    lastFour: typebox_1.Type.Optional(typebox_1.Type.String()),
    bankName: typebox_1.Type.Optional(typebox_1.Type.String()),
    accountType: typebox_1.Type.Optional(exports.AchAccountType),
    accountHolderType: typebox_1.Type.Optional(exports.AchAccountHolderType),
});
exports.AchAccountTypeLabels = {
    CHECKING: 'Checking',
    SAVINGS: 'Savings',
};
exports.AchAccountHolderTypeLabels = {
    PERSONAL: 'Personal',
    BUSINESS: 'Business',
};
/**
 * The address on file with the processor. Every field is optional because the processor is free to
 * hold a partial one, which the required fields of `AddressTransport` would reject.
 */
exports.ProcessingPaymentMethodBillingContact = typebox_1.Type.Composite([
    typebox_1.Type.Object({ name: typebox_1.Type.Optional(typebox_1.Type.String()) }),
    typebox_1.Type.Partial(common_1.AddressTransport),
]);
/**
 * The stored method as we describe it, whichever processor holds it. Nested rather than spread so
 * these names never collide with the processor's own, which is what forced the previous reshuffle.
 */
exports.ProcessingPaymentMethodCommonDetails = typebox_1.Type.Object({
    holderName: typebox_1.Type.Optional(typebox_1.Type.String()),
    billingContact: typebox_1.Type.Optional(exports.ProcessingPaymentMethodBillingContact),
});
/** A card method, or Apple Pay, which is card-backed. */
exports.CardProcessingPaymentMethodDetails = typebox_1.Type.Composite([
    exports.ProcessingPaymentMethodCommonDetails,
    typebox_1.Type.Object({ card: exports.ProcessingCardBackedFields }),
]);
exports.AchProcessingPaymentMethodDetails = typebox_1.Type.Composite([
    exports.ProcessingPaymentMethodCommonDetails,
    typebox_1.Type.Object({ bankAccount: exports.ProcessingAchBackedFields }),
]);
/** A PayPal or Venmo wallet, which the processor describes by the account's email and nothing else. */
exports.WalletProcessingPaymentMethodDetails = typebox_1.Type.Composite([
    exports.ProcessingPaymentMethodCommonDetails,
    typebox_1.Type.Object({ email: typebox_1.Type.Optional(typebox_1.Type.String()) }),
]);
/**
 * Rainforest-specific payment method `type`s to our normalized enum.
 */
exports.RAINFOREST_METHOD_TYPE_TO_STORED = {
    CARD: 'CARD',
    APPLE_PAY: 'APPLE_PAY',
    ACH: 'ACH',
    // Plaid is only how the account was linked — the stored method is still an ACH bank account
    PLAID_ACH: 'ACH',
    PAYPAL_WALLET: 'PAYPAL_WALLET',
    VENMO: 'VENMO',
    // PayPal Pay Later can't be stored as a Rainforest payment method
    PAYPAL_PAYLATER: null,
};
const toDetailsForType = (processorPaymentMethod, type) => {
    const { card, apple_pay: applePay, ach, plaid_ach: plaidAch, billing_contact: billingContact, } = processorPaymentMethod;
    const common = {
        holderName: billingContact?.name,
        ...(billingContact
            ? {
                billingContact: {
                    name: billingContact.name,
                    addressLine1: billingContact.address_line_1,
                    addressLine2: billingContact.address_line_2,
                    city: billingContact.city,
                    state: billingContact.state,
                    zip: billingContact.postal_code,
                    country: billingContact.country,
                },
            }
            : {}),
    };
    if (type === stored_payment_method_type_1.STORED_PAYMENT_METHOD_CARD || type === stored_payment_method_type_1.STORED_PAYMENT_METHOD_APPLE_PAY) {
        return {
            type,
            details: {
                ...common,
                card: {
                    brand: applePay?.brand ?? card?.brand,
                    brandDescription: applePay?.brand_desc ?? card?.brand_desc,
                    // Rainforest reports an Apple Pay method's digits inside a display string, not a field of its own.
                    lastFour: applePay ? applePay.description?.replace(/\D/g, '') : card?.last_4,
                    expirationMonth: card?.exp_month,
                    expirationYear: card?.exp_year,
                },
            },
        };
    }
    if (type === stored_payment_method_type_1.STORED_PAYMENT_METHOD_ACH) {
        // Plaid is only how the account was linked, so it is reported as ACH; the link is what validates it.
        const bankAccount = plaidAch ?? ach;
        return {
            type,
            details: {
                ...common,
                bankAccount: {
                    lastFour: bankAccount?.account_number_last_4,
                    bankName: bankAccount?.bank_name,
                    accountType: bankAccount?.account_type,
                    accountHolderType: bankAccount?.account_holder_type,
                },
            },
        };
    }
    return { type, details: common };
};
/**
 * Describes a processor's stored method in our own terms, paired with the type the processor says it
 * is, so the caller receives a `type` and a `details` that already agree. A method the processor did
 * not type, or typed as something we cannot store, comes back untyped rather than guessed at.
 */
const toTypedProcessingPaymentMethodDetails = (processorPaymentMethod) => {
    const type = processorPaymentMethod.method_type
        ? exports.RAINFOREST_METHOD_TYPE_TO_STORED[processorPaymentMethod.method_type]
        : null;
    return type
        ? toDetailsForType(processorPaymentMethod, type)
        : { type: null, details: { holderName: processorPaymentMethod.billing_contact?.name } };
};
exports.toTypedProcessingPaymentMethodDetails = toTypedProcessingPaymentMethodDetails;
/**
 * Describes a stored association with what the processor knows about it. Built here rather than by
 * the caller so `type` and `details` are chosen together — spreading them into a literal separately
 * loses the correlation the union depends on.
 */
const enrichCustomerPaymentMethod = ({ customerPaymentMethod, processorPaymentMethod, }) => {
    const common = {
        customerPaymentMethodID: customerPaymentMethod.id,
        status: customerPaymentMethod.status,
        note: customerPaymentMethod.latestStatusNote,
        processorPaymentMethodID: processorPaymentMethod.payment_method_id ?? '',
        fingerprint: processorPaymentMethod.fingerprint,
    };
    // The processor is the authority; the stored column covers what it will not type.
    const type = (processorPaymentMethod.method_type
        ? exports.RAINFOREST_METHOD_TYPE_TO_STORED[processorPaymentMethod.method_type]
        : null) ?? ((0, stored_payment_method_type_1.isStoredPaymentMethodType)(customerPaymentMethod.type) ? customerPaymentMethod.type : null);
    if (!type) {
        return undefined;
    }
    return { ...common, ...toDetailsForType(processorPaymentMethod, type) };
};
exports.enrichCustomerPaymentMethod = enrichCustomerPaymentMethod;
exports.CustomerPaymentMethodTransport = typebox_1.Type.Object({
    id: typebox_1.Type.String(),
    haulerID: typebox_1.Type.String({ format: 'uuid' }),
    customerID: typebox_1.Type.String({ format: 'uuid' }),
    paymentMethodID: typebox_1.Type.String(),
    paymentMethodFingerprint: typebox_1.Type.Optional(typebox_1.Type.String()),
    type: stored_payment_method_type_1.StoredPaymentMethodType,
    status: exports.CustomerPaymentMethodStatusSchema,
    latestStatusNote: typebox_1.Type.Optional(exports.CustomerPaymentMethodStatusNoteTransport),
    createdAt: typebox_1.Type.String({ format: 'date-time' }),
    lastUpdatedAt: typebox_1.Type.String({ format: 'date-time' }),
});
exports.CustomerPaymentMethodUpdateTransport = typebox_1.Type.Object({
    paymentMethodID: typebox_1.Type.String({ minLength: 1, maxLength: 255 }),
    paymentMethodFingerprint: typebox_1.Type.Optional(typebox_1.Type.String()),
    type: stored_payment_method_type_1.StoredPaymentMethodType,
    status: exports.CustomerPaymentMethodStatusSchema,
    statusReason: typebox_1.Type.Optional(exports.CustomerPaymentMethodStatusReasonSchema),
    statusNote: typebox_1.Type.Optional(typebox_1.Type.String({ maxLength: 2000 })),
});
exports.ListCustomerPaymentMethodsQuery = typebox_1.Type.Object({
    type: typebox_1.Type.Optional(stored_payment_method_type_1.StoredPaymentMethodType),
    includeStatuses: typebox_1.Type.Optional(typebox_1.Type.String()), // Comma separated list of statuses
});
exports.CustomerPaymentMethodPartialUpdateTransport = typebox_1.Type.Pick(exports.CustomerPaymentMethodUpdateTransport, [
    'status',
    'statusReason',
    'statusNote',
]);
/**
 * Spelled out rather than composed from `AddressTransport` so the accepted lengths stay on the
 * fields the caller submits; the shared schema carries names and formats but no length bounds.
 */
exports.CustomerPaymentMethodBillingContactUpdateTransport = typebox_1.Type.Object({
    name: typebox_1.Type.Optional(typebox_1.Type.String({ maxLength: 200 })),
    addressLine1: typebox_1.Type.Optional(typebox_1.Type.String({ maxLength: 200 })),
    addressLine2: typebox_1.Type.Optional(typebox_1.Type.String({ maxLength: 200 })),
    city: typebox_1.Type.Optional(typebox_1.Type.String({ maxLength: 100 })),
    state: typebox_1.Type.Optional(typebox_1.Type.String({ maxLength: 100 })),
    zip: typebox_1.Type.Optional(typebox_1.Type.String({ maxLength: 20 })),
    country: typebox_1.Type.Optional(typebox_1.Type.String({ maxLength: 2 })),
});
//# sourceMappingURL=payment-method-transport.js.map